import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyCOMrL_VnjaUTvFIoRQYFj9LB908k-zGq0",
  authDomain: "flutterapp-e7248.firebaseapp.com",
  projectId: "flutterapp-e7248",
  storageBucket: "flutterapp-e7248.firebasestorage.app",
  messagingSenderId: "996396083527",
  appId: "1:996396083527:web:e9972d59a2f9ef909d8462",
  measurementId: "G-ZLN3V6SCZQ",
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export default app;
